import angular from "angular";
import { sentryExceptionHandlerDecorator } from "./sentry-exception-handler.decorator";
import { SentryHubProvider } from "./sentry-hub.provider";
import { sentryLogDecorator } from "./sentry-log.decorator";

export const SentryModule = angular
    .module("apex.ext.sentry", [])
    .provider("sentryExceptionHandlerHub", SentryHubProvider)
    .provider("sentryLogHub", SentryHubProvider)
    .decorator("$exceptionHandler", sentryExceptionHandlerDecorator)
    .decorator("$log", sentryLogDecorator)
    .name;
